/**
 * Seated-event tier designation (matches host app / API).
 * Missing on legacy tiers is treated as `both` (server default).
 */
export type FeeTierDesignation = 'ticket' | 'table' | 'both';

export function normalizeFeeTierDesignation(raw: unknown): FeeTierDesignation {
  if (raw === 'ticket' || raw === 'table' || raw === 'both') return raw;
  return 'both';
}

/** GA / ticket quantity flow: tiers buyers can purchase as regular tickets. */
export function tierEligibleForTicketCheckout(raw: unknown): boolean {
  const n = normalizeFeeTierDesignation(raw);
  return n === 'ticket' || n === 'both';
}

/** Table reservation / lounge pricing: tiers that apply to tables. */
export function tierEligibleForTableOrChairPricing(raw: unknown): boolean {
  const n = normalizeFeeTierDesignation(raw);
  return n === 'table' || n === 'both';
}

/** First tier for table holds / default currency in table flow (seated: prefers table/both). */
export function firstWidgetFeeTierForTableFlow<T extends { designation?: unknown }>(
  feeStructures: T[],
  seatedEvent: boolean,
): T | undefined {
  if (!feeStructures.length) return undefined;
  if (!seatedEvent) return feeStructures[0];
  const row = feeStructures.find((f) => tierEligibleForTableOrChairPricing(f.designation));
  return row ?? feeStructures[0];
}
